import AddCard from '../../../../banking/components/add-card/AddCard';

const AddCardScreen = () => {
    return <AddCard />;
};

export default AddCardScreen;
